import * as Sentry from "@sentry/react";
import { beforeSendScrub, DENY_URL_LIST, IGNORE_ERRORS } from "./sentryFilters";

/** Inyectado por vite (define en vite.config.ts). 'web' fuera de Tauri. */
declare const __TRD_PLATFORM__: "web" | "desktop";

let initialized = false;

/**
 * Inicializa Sentry una sola vez. No-op si `VITE_SENTRY_DSN` no está seteado,
 * para que dev local sin DSN siga funcionando sin warnings.
 */
export function initSentry(): void {
  if (initialized) return;

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // `release` lo inyecta @sentry/vite-plugin en build cuando hay
    // SENTRY_AUTH_TOKEN. En dev queda undefined, que está OK.
    release: import.meta.env.VITE_SENTRY_RELEASE,
    // Sin performance ni replay en step 2; se prenden cuando tengamos
    // datos reales de qué flujos vale la pena instrumentar.
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    ignoreErrors: IGNORE_ERRORS,
    denyUrls: DENY_URL_LIST,
    beforeSend: beforeSendScrub,
    initialScope: {
      tags: { platform: __TRD_PLATFORM__ },
    },
  });

  // En dev exponemos el SDK en window para poder disparar smoke tests
  // desde devtools sin tocar código. No se expone en prod.
  if (import.meta.env.DEV && typeof window !== "undefined") {
    (window as unknown as { __sentry: typeof Sentry }).__sentry = Sentry;
  }

  initialized = true;
}

export { Sentry };
